import { Component, OnInit, ViewChild } from '@angular/core';
import { BlogService } from 'src/app/services/blog.service';
import { BlogPost } from 'src/app/models/blogpost';
import { ActivatedRoute, Router } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  public postLoaded:boolean=false;
  public postId;
  public post: BlogPost;
  public environment=environment;
  public Editor = ClassicEditor;
  @ViewChild("bodyEditor", {static: false}) bodyEditor:any;

  constructor(
    private _post: BlogService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _notify: NotificationService
  ) {
    this.postId=this._route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getPost();
  }

  public getPost(){
    this._post.getPost(this.postId).subscribe(
      data=>{
        this.post=new BlogPost(data);
        this.postLoaded=true;
      }
    );
  }

  public getListingImageData(data:any){
    this.post.newTileImageType=data[0];
    this.post.newTileImageB64=data[1];
  }

  public getMainImageData(data:any){
    this.post.newMainImageType=data[0];
    this.post.newMainImageB64=data[1];
  }

  public updatePost(){
    if(this.post.title=='') return this._notify.showMessage('Title can not be blank.', 'OK');
    if(this.post.body=='') return this._notify.showMessage('Body can not be blank.', 'OK');
    this._post.updatePost(this.post).subscribe(
      res=>{
        this._notify.showMessage('Article updated.', 'OK');
        this.post=res;
      }
    );
  }

  public deletePost(){
    if(!confirm('Confirm deletion of this Article.')) return false;
    this._post.deletePost(this.postId).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
        this._router.navigate(['/articles']);
      }
    );
  }

  formatPublishDate(event){
    this.post.publish_date=event.value.toISOString();
  }
}
